"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FacetsContext = void 0;
exports.useFacets = useFacets;
exports.useUpdateFilter = exports.useGetANGConfig = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var qs = _interopRequireWildcard(require("querystring"));
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var _exchangeSearchCommon = require("@mulesoft/exchange-search-common");
var _react = _interopRequireDefault(require("react"));
var _types = require("./types");
var _config = _interopRequireDefault(require("./config"));
var constants = _interopRequireWildcard(require("../constants"));
var _utils = require("./utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const getFacetTerm = facet => {
  if (facet === 'customer-metadata.CustomerMetadataNode.categories') {
    return '_aggr_category_t';
  }
  return '_aggr_tag_t';
};
const useProfileOrganizationId = () => {
  const profile = (0, _exchangeReactHooks.useProfile)();
  const organizationId = profile === null || profile === void 0 ? void 0 : profile.organization.id;
  return organizationId;
};
const useGetFacetsURL = (organizationId, fixedTypes) => {
  const assetTypesConfiguration = (0, _exchangeReactHooks.useAssetTypesConfiguration)();
  const profileOrganizationId = useProfileOrganizationId();
  const targetOrganizationId = organizationId !== null && organizationId !== void 0 ? organizationId : profileOrganizationId;
  return _react.default.useCallback(({
    query,
    facet,
    facets
  }) => {
    var _query$field;
    let angTypes;
    if (fixedTypes !== null && fixedTypes !== void 0 && fixedTypes.length) {
      const fixedANGTypes = (0, _exchangeSearchCommon.getANGTypes)(fixedTypes, assetTypesConfiguration);
      angTypes = !query.type || query.type.length === 0 ? fixedANGTypes : fixedANGTypes.filter(fixedANGType => query.type.some(type => type === fixedANGType));
    } else {
      angTypes = query.type;
    }
    const parsedQuery = _objectSpread(_objectSpread({}, query), {}, {
      field: (0, _utils.processCustomFields)((_query$field = query.field) !== null && _query$field !== void 0 ? _query$field : [], facets),
      type: angTypes
    });
    const stringified = qs.stringify(parsedQuery);
    const url = `/api/v2/${targetOrganizationId ? `organizations/${targetOrganizationId}/` : ''}ang/facets${facet ? `/${facet}` : ''}?${stringified}`;
    return url;
  }, [assetTypesConfiguration]);
};
const useGetANGConfig = props => {
  const {
    maxResults,
    fixedTypes,
    fixedStatuses,
    facets,
    searchFilters,
    angQuery,
    updateFilter,
    boostConfiguration
  } = props;
  const assetTypesConfiguration = (0, _exchangeReactHooks.useAssetTypesConfiguration)();
  const profile = (0, _exchangeReactHooks.useProfile)();
  const config = (0, _exchangeReactHooks.useConfig)();
  const featureFlags = (0, _exchangeReactHooks.useFeatureFlags)();
  const context = (0, _exchangeReactHooks.useSessionContext)();
  const getANGConfig = _react.default.useCallback(sort => (0, _config.default)(assetTypesConfiguration, config, profile, context, featureFlags, maxResults, fixedTypes, fixedStatuses, facets, searchFilters, angQuery, updateFilter, boostConfiguration, sort), [facets, boostConfiguration, searchFilters, context, updateFilter]);
  return getANGConfig;
};
exports.useGetANGConfig = useGetANGConfig;
const useUpdateFilter = (query, onFilterUpdate, organizationId, fixedTypes) => {
  const getFacetsURL = useGetFacetsURL(organizationId, fixedTypes);
  const fetch = (0, _exchangeReactHooks.useFetch)();
  const [terms, setTerms] = _react.default.useState({});
  const callback = _react.default.useCallback(async (term, facet) => {
    var _terms$facet;
    const lastTerm = (_terms$facet = terms[facet]) !== null && _terms$facet !== void 0 ? _terms$facet : '';
    if (term !== lastTerm) {
      const queryWithTerm = _objectSpread(_objectSpread({}, query), {}, {
        [getFacetTerm(facet)]: term
      });
      const url = getFacetsURL({
        query: queryWithTerm,
        facet
      });
      const response = await fetch(url);
      const facets = await response.json();
      setTerms($terms => _objectSpread(_objectSpread({}, $terms), {}, {
        [facet]: term
      }));
      onFilterUpdate($facets => _objectSpread(_objectSpread({}, $facets), facets));
    }
  }, [onFilterUpdate]);
  return callback;
};
exports.useUpdateFilter = useUpdateFilter;
const SEARCH_FILTER_POPULATED = 'Search filter populated';

/**
 * groups date custom fields by year + month + day
 *
 * @param fields custom fields obtained from facets
 * @returns grouped custom fields
 */
const groupCustomFields = (fields = []) => {
  return fields.reduce((accum, field) => {
    // groups dates from the same day together since the interface does not allow to see hour+minute
    if (field.dataType === _types.FacetsCustomFieldType.Date) {
      const date = (0, _utils.decomposeDate)(field.value);

      // filter out invalid dates
      if (!date) {
        return accum;
      }

      // check for repeated values
      if (accum.some(item => item.value === date)) {
        return accum;
      }
      return [...accum, _objectSpread(_objectSpread({}, field), {}, {
        value: date
      })];
    }

    // other data types does not have to be modified
    return [...accum, field];
  }, []);
};
const processFacetsResponse = json => {
  var _json$categories, _json$tags;
  return _objectSpread(_objectSpread({}, json), {}, {
    fields: groupCustomFields(json.fields),
    hasCategoriesFilter: ((_json$categories = json.categories) === null || _json$categories === void 0 ? void 0 : _json$categories.length) >= constants.MAX_ANG_FACETS_RESULTS,
    hasTagsFilter: ((_json$tags = json.tags) === null || _json$tags === void 0 ? void 0 : _json$tags.length) >= constants.MAX_ANG_FACETS_RESULTS
  });
};
function useFacets(query, filters, organizationId, fixedTypes, callback) {
  const fetch = (0, _exchangeReactHooks.useFetch)();
  const tryFn = (0, _exchangeReactHooks.useTryFn)();
  const trackEvent = (0, _exchangeReactHooks.useAnalyticsTracking)();
  const assetTypesConfiguration = (0, _exchangeReactHooks.useAssetTypesConfiguration)();
  const [facets, setFacets] = _react.default.useState();
  const getFacetsURL = useGetFacetsURL(organizationId, fixedTypes);
  const url = getFacetsURL({
    query
  });
  _react.default.useEffect(() => {
    async function init() {
      const start = Date.now();
      const response = await fetch(url);
      const json = await response.json();
      const responseTime = Date.now() - start;
      const result = processFacetsResponse(json);
      setFacets(result);
      callback === null || callback === void 0 || callback(result);
      const types = Object.keys(assetTypesConfiguration).filter(typeKey => {
        var _json$types;
        if (typeKey === 'default') {
          return false;
        }
        const type = assetTypesConfiguration[typeKey];
        return (_json$types = json.types) === null || _json$types === void 0 ? void 0 : _json$types.some(selectedType => selectedType === type.angType);
      });
      const compiledFilters = {
        types,
        categories: json.categories,
        tags: json.tags,
        customFields: json.fields,
        organizations: json.organizations.map(({
          id,
          isMaster
        }) => ({
          id,
          isMaster
        }))
      };
      Object.keys(compiledFilters).forEach(filter => {
        var _compiledFilters$filt;
        if ((_compiledFilters$filt = compiledFilters[filter]) !== null && _compiledFilters$filt !== void 0 && _compiledFilters$filt.length) {
          trackEvent(SEARCH_FILTER_POPULATED, {
            filter,
            query,
            count: compiledFilters[filter].length,
            values: compiledFilters[filter],
            responseTime
          });
        }
      });
    }
    if ((filters === null || filters === void 0 ? void 0 : filters.length) > 0) {
      tryFn(init);
    } else {
      callback === null || callback === void 0 || callback(null);
    }
  }, [url, filters === null || filters === void 0 ? void 0 : filters.join('-')]);
  return [facets, setFacets];
}
const FacetsContext = exports.FacetsContext = /*#__PURE__*/_react.default.createContext(null);
//# sourceMappingURL=hooks.js.map